export default __webpack_public_path__ + "locales/fr/Translations.json?hash=b9b903d39259af4c89e930c4b68bddc9";